<template>
  <b-row class="match-height">
    <b-col v-for="card in cards" :key="card.key" xl="" lg="4" md="6" class="dashboard-growth-col">
      <statistic-card-with-area-chart
        :icon="card.icon"
        :color="card.color"
        :statistic="card.statistic"
        :statistic-title="card.title"
        :chart-data="card.series"
      />
    </b-col>
  </b-row>
</template>

<script>
import { BRow, BCol } from 'bootstrap-vue'
import { computed } from '@vue/composition-api'
import StatisticCardWithAreaChart from '@core/components/statistics-cards/StatisticCardWithAreaChart.vue'
import { formatNumber } from '@/views/dashboard/sifnf/utils'

const ENTITIES = [
  { key: 'artists', title: 'артистов', icon: 'MicIcon', color: 'primary', total: 'artists' },
  { key: 'tracks', title: 'треков', icon: 'MusicIcon', color: 'success', total: 'tracks' },
  { key: 'movies', title: 'фильмов', icon: 'FilmIcon', color: 'warning', total: 'movies' },
  { key: 'strips', title: 'полосок', icon: 'LayersIcon', color: 'info', total: 'strips' },
  { key: 'generator_packs', title: 'пакетов генератора', icon: 'PackageIcon', color: 'danger', total: null },
]

export default {
  components: { BRow, BCol, StatisticCardWithAreaChart },
  props: {
    growth: { type: Object, default: null },
    totals: { type: Object, default: null },
  },
  setup(props) {
    const cards = computed(() => ENTITIES.map(entity => {
      const growth = (props.growth && props.growth[entity.key]) || { daily: [], last_7: 0, last_30: 0 }
      const total = entity.total && props.totals ? props.totals[entity.total] : null
      return {
        key: entity.key,
        icon: entity.icon,
        color: entity.color,
        statistic: `+${formatNumber(growth.last_30)}`,
        title: `${entity.title} за 30 дн.${total != null ? ` · всего ${formatNumber(total)}` : ''} · за 7 дн. +${formatNumber(growth.last_7)}`,
        series: [{ name: 'за день', data: growth.daily }],
      }
    }))
    return { cards }
  },
}
</script>

<style lang="scss" scoped>
// 5 карточек в ряд на xl: xl="" даёт col-xl (равные колонки)
.dashboard-growth-col { min-width: 0; }
</style>
